<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    scrollable>
    <template #activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        class="px-4"
        color="primary"
        depressed
        outlined
        v-on="on">
        ดูตัวอย่าง
      </v-btn>
    </template>
    <v-card
      class="barcode-preview"
      color="#F0F2F5">
      <v-card-title></v-card-title>
      <v-card-text class="d-flex flex-column">
        <div class="d-flex justify-center align-center gap-6 mb-6">
          <v-btn
            color="primary"
            icon
            @click="goToPage(page-1)">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <div>{{ page }} of {{ items.length }}</div>
          <v-btn
            color="primary"
            icon
            @click="goToPage(page+1)">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </div>
        <div
          ref="barcodePreview"
          class="barcode-preview__container modern-scrollbar overflow-auto h-100">
          <div class="mx-auto">
            <template v-for="p in items.length">
              <BarcodePaper
                :id="`barcode-${p}`"
                :ref="`barcode-${p}`"
                :key="`barcode-${p}`"
                :items="[items[p - 1]]"
                :elements="elements"
                :width="width"
                :height="height"
                :col="col"
                :row="row"
                :my="my"
                :mx="mx"
                :omy="omy"
                :omx="omx"
                :imy="imy"
                :font-size="fontSize"
                :show-barcode-number="showBarcodeNumber"
                class="barcode-preview__paper" />
            </template>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          class="pr-4"
          color="primary"
          depressed
          rounded
          @click="download()">
          <v-icon left>
            mdi-download
          </v-icon>
          Download
        </v-btn>
        <v-btn
          class="ml-6"
          color="primary"
          rounded
          text
          @click="setDialog(false)">
          ยกเลิก
        </v-btn>
        <v-btn
          color="primary"
          depressed
          rounded
          @click="submit()">
          พิมพ์
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { jsPDF } from 'jspdf'
import html2canvas from 'html2canvas'
import BarcodePaper from './BarcodePaper.vue'

export default {
  components: { BarcodePaper },
  props: {
    col: {
      type: [Number],
      default: 0
    },
    row: {
      type: [Number],
      default: 0
    },
    my: {
      type: [Number],
      default: 0
    },
    mx: {
      type: [Number],
      default: 0
    },
    omy: {
      type: [Number],
      default: 0
    },
    omx: {
      type: [Number],
      default: 0
    },
    imy: {
      type: [Number],
      default: 0
    },
    width: {
      type: [Number],
      default: 296
    },
    height: {
      type: [Number],
      default: 209
    },
    elements: {
      type: [Array],
      default: () => (['name', 'barcode', 'price'])
    },
    items: {
      type: Array,
      default: () => ([])
    },
    fontSize: {
      type: Number,
      default: 10
    },
    showBarcodeNumber: Boolean
  },
  data () {
    return {
      dialog: false,
      page: 1
    }
  },
  methods: {
    getCanvas (page = 1, callback) {
      const pxRatio = 3.7795275591 // 3.779528
      html2canvas(document.getElementById(`barcode-${page}`), {
        width: this.width * pxRatio,
        height: this.height * pxRatio
      }).then((canvas) => {
        callback(canvas.toDataURL('image/jpeg'), page)
      })
    },
    async download () {
      const doc = jsPDF({
        orientation: this.width > this.height ? 'l' : 'p',
        unit: 'mm',
        format: [this.width, this.height]
      })
      for (let i = 1; i <= this.items.length; i++) {
        this.getCanvas(i, (img, page) => {
          doc.addImage(img, 'jpeg', 0, 0, this.width, this.height)
          if (page === this.items.length) {
            doc.save(`barcode-${new Date().getTime()}`)
          } else {
            doc.addPage()
          }
        })
      }
    },
    submit () {
      this.$emit('submit')
      this.setDialog(false)
    },
    goToPage (page = 1) {
      if (page > 1) {
        this.page = page > this.items.length ? this.items.length : page
      } else {
        this.page = 1
      }
      const element = this.$refs[`barcode-${this.page}`]
      const top = element[0].$el.offsetTop

      this.$refs.barcodePreview.scrollTo({ top: top - 100, behavior: 'smooth' })
    },
    setPage (page = 1) {
      if (page > 1) {
        this.page = page > this.items.length ? this.items.length : page
      } else {
        this.page = 1
      }
    },
    setDialog (dialog = false) {
      this.dialog = dialog
    }
  }

}
</script>

<style lang="scss" scoped>
  .barcode-preview {
    &__container {
      background: #B5B5B5;
      padding: 30px;
    }
    &__paper {
      background: #ffffff;
      margin-bottom: 24px;
    }
  }
</style>
